import { render, staticRenderFns } from "./WhiteMain.vue?vue&type=template&id=0de65cfe"
import script from "./WhiteMain.vue?vue&type=script&lang=js"
export * from "./WhiteMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports